import { SceneState } from '../../components/SceneStatemachinePlugin';
import { BACKGROUND_MUSIC, INTERACTIONS } from '../../constants/Constants';
import { ActionsPlayer } from 'game/components/ActionsPlayer.js';
import { TRACK_COMPONENTS, TRACK_EVENTS } from 'game/tracking/stats.js';

// =============================================================================================
// STATE : COIN FLIP
// =============================================================================================
export class StateScenarioInteraction extends SceneState {
  constructor(scene, scenario) {
    super(scene);
    this._scenario = scenario;
    this._interactionConfig = INTERACTIONS.find((i) => i.id == scenario.interaction);
  }

  startState() {
    this.game.soundController.playMusic(BACKGROUND_MUSIC.INIFIC_SCREEN);
    const { configId } = this._scenario.emotion_interaction;
    this._config = this.game.cache.json.get(configId);
    const sceneCharacters = this._scenario.scene_objects
      .filter((o) => o.type === 'character')
      .map((c) => {
        return this.scene.getSceneObject(c.id, c.type);
      });
    const opts = { game: this.game, scene: this.scene, x: 0, y: 0, config: this._config };
    this._actionsPlayer = new ActionsPlayer(opts);
    this._actionsPlayer.addSceneCharacters(sceneCharacters);
    this._actionsPlayer.once('COMPLETE_ACTIONS', this.startInteraction, this);
    this._actionsPlayer.start();
  }

  startInteraction() {
    const { names = {} } = this._scenario.tracking;
    this.game.stats.setScreenName(names.INTERACTION1);
    const component = TRACK_COMPONENTS[this._interactionConfig.id.toUpperCase()];
    this.game.stats.startComponent(component);

    this.scene.subscene.events.on('shutdown', this.handleInteractionComplete, this);
    this.scene.subscene.start(
      this._interactionConfig.id,
      { tracking: names },
      { pauseMainScene: true }
    );
  }

  handleInteractionComplete() {
    console.log('handleInteractionComplete');
    const component = TRACK_COMPONENTS[this._interactionConfig.id.toUpperCase()];
    this.game.stats.completeComponent(component);
    this.emit('state_complete');
  }

  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {}
  endState() {
    if (this._actionsPlayer) {
      this._actionsPlayer.destroy();
      this._actionsPlayer = null;
    }
    this.scene.subscene.events.off('shutdown', this.handleInteractionComplete, this);
    this.scene.subscene.stop(this._interactionConfig.id);
  }
}
